import { Center, Loader, Stack } from '@mantine/core';
import React from 'react';

export interface DefaultLoaderProps {
    children?: React.ReactNode;
}

export const DefaultLoader = ({ children }: DefaultLoaderProps) => {
    return (
        <Center h={'100vh'}>
            <Stack align="center">
                <Loader size="xl" color="blue" />
                {children}
            </Stack>
        </Center>
    );
};
